<template>
    <div class="c-ontainer">
      <div class="left">
        <div class="box blue">
            <h5>📢 Campaign Management</h5>
            <div class="numbers-row">
                <h2>255</h2>
                <span>24%</span>
            </div>
        </div>
        <div class="box light-blue">
            <h5>🎯 Converted Lead</h5>
            <div class="numbers-row">
                <h2>255</h2>
                <span>24%</span>
            </div>

        </div>
        <div class="box navy">
            <h5>🤝 First Touch</h5>
            <div class="numbers-row">
                <h2>255</h2>
                <span>24%</span>
            </div>
        </div>
        <!-- <div class="box dark-blue">💻 CRM Software</div> -->
      </div>
      <!-- <div class="center">CRM</div> -->
      <div class="right">

        <div class="box orange">
            <h5>📊 CRM Reporting</h5>
            <div class="numbers-row">
                <h2>255</h2>
                <span>24%</span>
            </div>
        </div>
        <div class="box pink">
            <h5>🎧 Customer Journey</h5>
            <div class="numbers-row">
                <h2>255</h2>
                <span>24%</span>
            </div>

        </div>
        <div class="box dark-pink">
            <h5>💰 Lead Conversion</h5>
            <div class="numbers-row">
                <h2>255</h2>
                <span>24%</span>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style lang="scss">

  .demo .c-ontainer {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    //align-items: center;
    //gap: 40px;
    //justify-content: space-between;
  }
  .center {
    background: #fff;
    padding: 60px;
    border-radius: 50%;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
  }
  .left, .right {
    display: flex;
    gap: 10px;
    width: 100%;
  }
  .box {
    width: 100%;
    padding: 15px;
    border-radius: 25px;
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .numbers-row{
        //background-color: #E67E22;
        //padding: 10px 25px 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
            font-size: 18px;
            
        }
    }
  }
  .blue { background: #4A90E2; }
  .light-blue { background: #5DADE2; }
  .dark-blue { background: #2C3E50; }
  .navy { background: #1B4F72; }
  .yellow { background: #F4D03F; }
  .orange { background: #E67E22; }
  .pink { background: #EC7063; }
  .dark-pink { background: #C0392B; }
  </style>
  